<template>
  <div>
    <span class="fs-3">Notifications Manager</span>
  </div>
</template>

<script setup></script>

<style scoped></style>
